/* Be One Atelier, efectos de la portada (cabecera, marquesina, indicador de scroll y animaciones de entrada) */
(function () {
  var d = document;
  var root = d.documentElement;
  var inEditor = window.Shopify && window.Shopify.designMode;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (d.readyState !== 'loading') fn();
    else d.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Enlace "Preferencias de cookies" del pie: abre el panel de consentimiento de Shopify */
    document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href*="shopifyReshowConsentBanner"], a[href="#preferencias-cookies"]'); if (a && window.privacyBanner && window.privacyBanner.showPreferences) { e.preventDefault(); window.privacyBanner.showPreferences(); } });
    // Cabecera translúcida al bajar
    var onScroll = function () { d.body.classList.toggle('bo-scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var top = d.querySelector('[id$="__section_6f9HaL"]');

    // Indicador de scroll en el vídeo inicial
    if (top && !top.querySelector('.bo-cue')) {
      var next = top.nextElementSibling;
      var cue = d.createElement('a');
      cue.className = 'bo-cue';
      cue.href = next && next.id ? '#' + next.id : '#MainContent';
      cue.setAttribute('aria-label', 'Bajar al contenido');
      cue.innerHTML = '<span>Descubre</span><span class="bo-cue__line" aria-hidden="true"></span>';
      var sec = top.querySelector('.section') || top;
      sec.appendChild(cue);
    }

    // Marquesina editorial bajo el vídeo inicial
    if (top && !d.querySelector('.bo-marquee')) {
      var phrases = ['Be One Atelier', 'Bolsos de piel hechos en España', 'Diseñados para permanecer', 'Piel certificada'];
      var item = '<div class="bo-marquee__item">' + phrases.map(function (p) {
        return '<span>' + p + '</span><span class="bo-marquee__dot" aria-hidden="true"></span>';
      }).join('') + '</div>';
      var mq = d.createElement('div');
      mq.className = 'bo-marquee';
      mq.setAttribute('aria-hidden', 'true');
      mq.innerHTML = '<div class="bo-marquee__track">' + item + item + '</div>';
      top.insertAdjacentElement('afterend', mq);
    }

    // Párrafos vacíos (solo saltos de línea) que descuadran los mosaicos
    d.querySelectorAll('[id$="__section_hKMaJJ"] .text-block p').forEach(function (p) {
      if (!p.textContent.replace(/ /g, ' ').trim()) p.classList.add('bo-empty');
    });

    if (inEditor || reduce || !('IntersectionObserver' in window)) return;

    root.classList.add('bo-js');

    var groups = [
      '[id$="__section_xj9hKY"] .image-block',
      '[id$="__section_xj9hKY"] .group-block-content > *',
      '.section-resource-list__header',
      '.resource-list__item',
      '[id$="__section_hKMaJJ"] .group-block',
      '[id$="__section_3yP4VY"] .group-block',
      '[id$="__hero_g3aYzF"] .hero__content-wrapper > *',
      '[id$="__hero_MVUtj6"] .hero__content-wrapper > *',
      '[id$="__hero_fK6hyy"] .hero__content-wrapper > *',
      '[id$="__section_NjEdHQ"] .section-content-wrapper > *'
    ];
    var els = Array.prototype.slice.call(d.querySelectorAll(groups.join(',')));

    els.forEach(function (el) {
      el.classList.add('bo-r');
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--bo-d', (Math.min(Math.max(i, 0), 6) * 0.12).toFixed(2) + 's');
    });

    var img = d.querySelector('[id$="__section_xj9hKY"] .image-block');
    if (img) img.classList.add('bo-mask');

    var zoom = d.querySelector('[id$="__hero_g3aYzF"]');
    if (zoom) { zoom.classList.add('bo-zoom'); els.push(zoom); }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('bo-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

    els.forEach(function (el) { io.observe(el); });

    // Red de seguridad: nada se queda oculto si el observador falla
    setTimeout(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('bo-in');
      });
    }, 2500);
  });
})();
